<template>
    <b-dropdown position="is-bottom-left" class="notifications">
        <a class="navbar-item" slot="trigger" @click="handleNotification">
            <span class="badge is-badge-info is-badge-small" :data-badge="hasNotification">
                <b-icon icon="bell"></b-icon>
            </span>
        </a>

        <b-dropdown-item custom paddingless v-for="(item, $index) in notifications" :key="$index">
            <a href="">
                <article class="message">
                    <div class="message-body" v-if="item.data">
                        {{ item.data.message }}
                    </div>
                </article>
            </a>
        </b-dropdown-item>
        <infinite-loading @infinite="getData" ref="infinite">
            <div slot="no-more">
                <b-notification>
                    No más notificaciones
                </b-notification>
            </div>
            <div slot="no-results">
                <b-notification>
                    Sin notificaciones
                </b-notification>
            </div>
        </infinite-loading>
    </b-dropdown>
</template>

<script>
    import LaravelEcho from 'laravel-echo'

    export default {
        name: "NotificationNav",
        data() {
            return {
                notifications: [],
                hasNotification: null,
                page: 1,
            }
        },
        mounted() {
            this.prepareComponent()
        },
        destroyed() {
            if(this.echo){
                this.echo.leave(`App.Models.User.${this.$auth.user().id}`);
            }
        },
        methods: {
            prepareComponent() {
                let Echo = new LaravelEcho(this.$backend.socketHeaders());
                this.echo = Echo;
                Echo.private(`App.Models.User.${this.$auth.user().id}`)
                    .notification(e => {
                        this.hasNotification = '';
                        if(this.$refs.infinite){
                            this.$refs.infinite.stateChanger.reset();
                        }
                        this.page = 1;
                        this.notifications = [];
                        switch(e.type){
                            case 'App\\Notifications\\Ivr\\NewCallNotification':
                                this.$store.commit('currentCall', e.data);
                                // this.$emit('incoming-call', e);
                                break;
                            case 'App\\Notifications\\Ivr\\OutcomingNotification':
                                // this.$emit('outcoming-call', e);
                                break;
                            case 'App\\Notifications\\Ivr\\WorkerStatusNotification':
                                console.log('WorkerStatus: ' + e.data.name);
                                this.$emit('worker-update', {status: e.data.name});
                                break;
                            case 'App\\Notifications\\Ivr\\InvalidPhoneNumberNotification':
                                this.$emit('invalid-phone-number');
                                break;
                            default:
                                let sound = new Audio('/sounds/plucky.mp3');
                                sound.play();
                                break;
                        }

                    });
            },
            getData($state) {
                this.$http.get('notification', {
                    params: {
                        page: this.page,
                    },
                }).then(({data}) => {
                    let items = data.data || [];
                    if (items.length) {
                        this.page += 1;
                        this.notifications = this.notifications.concat(items);
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                });
            },
            handleNotification() {
                this.hasNotification = null;
                setTimeout(() => {
                    this.$refs.infinite.attemptLoad();
                }, 100)
            }
        }
    }
</script>

<style lang="scss">
    .notifications .dropdown-menu {
        min-width: 280px;
        max-height: 300px;
        overflow-y: auto;
    }
</style>
